import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Outcomes',
      type: 'table',
      content: {
        '{}': {
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Code',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'descr',
                  direct: {
                    '{}': {
                      name: 'Description',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
          query: {
            '`': {
              target: 'dim::!outcomes',
              filter: {
                and: [
                  {
                    '=': [
                      { '@_': ['parent', 'id'] },
                      { '``': { '@$': 'currentEntityId' } },
                    ],
                  },
                  {
                    '=': [
                      { '@^': 'parent' },
                      { '``': { '@$': 'currentRecordId' } },
                    ],
                  },
                ],
              },
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    '{}': {
                      action: {
                        '{}': {
                          operation: 'ui.navigate',
                          payload: {
                            '{}': {
                              goto: {
                                '{}': {
                                  variables: {
                                    '{}': {
                                      currentEntityId: {
                                        '@_': 'id',
                                      },
                                      currentRecordId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
              sort: {
                by: { '@.': '!code' },
              },
            },
          },
          count: {
            '`': {
              selection: { '#': { '@': 'records' } },
              subqueries: {
                records: {
                  target: 'dim::!outcomes',
                  filter: {
                    and: [
                      {
                        '=': [
                          { '@_': ['parent', 'id'] },
                          { '``': { '@$': 'currentEntityId' } },
                        ],
                      },
                      {
                        '=': [
                          { '@^': 'parent' },
                          { '``': { '@$': 'currentRecordId' } },
                        ],
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  sort: {
    by: { '@.': '!code' },
  },
}
